'use strict'

import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getNews (page) {
  apiConsolelog('api: getNews(): page = %d', page)

  return request({
    url: '/news/all',
    method: 'get',
    page
  })
}

export function showNews (id) {
  apiConsolelog('api: showNews(): id = %s', id)

  return request({
    url: '/front-news/' + id,
    method: 'get'
  })
}
